/* MEDIA MALL theme — nav + dropdown behavior */

const toggle = document.querySelector('.nav-toggle');
const nav = document.querySelector('.main-nav');
if (toggle && nav) {
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
  });
}

document.querySelectorAll('.dropdown > button').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const dd = btn.parentElement;
    const open = dd.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
  });
});

document.addEventListener('click', (e) => {
  document.querySelectorAll('.dropdown.is-open').forEach((dd) => {
    if (!dd.contains(e.target)) {
      dd.classList.remove('is-open');
      dd.querySelector('button').setAttribute('aria-expanded', 'false');
    }
  });
});
